import { Check, Close } from "@mui/icons-material";
import { Divider, List, ListItem, Typography } from "@mui/material";
import { alpha, Grid } from "@mui/system";

export const KdappontExamTraining2 = () => {
  return (
    <Grid size={6} justifyContent="space-between">
      <List
        sx={{
          fontSize: "1.8em",
          textAlign: "center",
        }}
      >
        <ListItem sx={{ fontWeight: "bold" }}>- Vragen?</ListItem>
        <ListItem sx={{ fontWeight: "bold" }}>
          - Werkprocessen tijdens het examen
          <a
            href="https://glrnl.sharepoint.com/sites/DigitaallesmateriaalIT/SitePages/KD-Appont2-4.aspx"
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: "none" }}
          >
            🔗
          </a>
        </ListItem>
        <ListItem sx={{ fontWeight: "bold" }}>
          - Denk aan validatie, ook SEO (H1, H2, alt-tags etc)
          <a href="https://validator.w3.org/" target="_blank" rel="noreferrer">
            (W3 Validator)
          </a>
        </ListItem>
        <ListItem sx={{ fontWeight: "bold" }}>- Test je code goed</ListItem>
        <ListItem sx={{ fontWeight: "bold" }}>
          - Tip: probeer deze onderdelen te verwerken in je prompts
        </ListItem>
        <ListItem sx={{ fontWeight: "bold" }}>
          - Gebruik vandaag om te oefenen met de onderdelen die je nog lastig
          vindt
        </ListItem>
      </List>
    </Grid>
  );
};
